import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full bg-canvas py-16 md:py-24" data-id="element-79" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto w-full max-w-narrow px-5 text-center md:px-8" data-id="element-80" data-mp="1o3dim06d3rlc">
        <span className="mx-auto flex h-20 w-20 items-center justify-center rounded-2xl bg-grass-500 text-white" data-id="element-81" data-mp="2223g3gx3fta8">
          <ShieldCheckIcon className="h-10 w-10" aria-hidden="true" data-id="element-82" data-mp="1x54p378q82g9" />
        </span>

        <h2 className="mt-7 font-display text-[2rem] font-extrabold leading-tight tracking-tight text-night md:text-5xl" data-id="element-83" data-mp="19faeyxfskrzp">
          Garanzia 100% soddisfazione o rimborso totale
        </h2>

        <div className="mt-9 rounded-2xl bg-white px-6 py-9 shadow-soft ring-1 ring-gray-200 md:px-10" data-id="element-84" data-mp="1j5c4zurpgkh9">
          <p className="text-lg leading-relaxed text-gray-600 md:text-xl" data-id="element-85" data-mp="1ed28fvw34m60">
            Se nei prossimi 7 giorni non ti sembra che il Protocollo sia esattamente quello che ti
            serviva per la tua campagna di Settembre Giallo, ti restituiamo ogni centesimo. Senza
            domande, senza caratteri piccoli, senza condizioni. Sappiamo che funziona perché lo
            abbiamo visto in centinaia di professionisti.{' '}
            <span className="font-display font-extrabold text-night" data-id="element-86" data-mp="tw9q12w2fy8g">Il tuo rischio è ZERO.</span>
          </p>
          <p className="mt-6 font-display text-lg font-extrabold leading-snug tracking-tight text-night md:text-xl" data-id="element-87" data-mp="12qwsbq6fnugh">
            Semplicemente rispondi alla nostra email dicendo che non fa per te, e elaboriamo il
            rimborso in 48 ore.
          </p>
        </div>
      </div>
    </section>;
}